import { render } from "./Trx.vue?vue&type=template&id=5176b434&scoped=true"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"

import "./Trx.vue?vue&type=style&index=0&id=5176b434&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5176b434"]])

export default __exports__